function timespanStringToSeconds (timespan) {
  const map = {
    '1h': 1 * 3600,
    '3h': 3 * 3600,
    '24h': 24 * 3600,
  }

  return map[timespan]
}

export {
  timespanStringToSeconds
}
